import { Input } from '@medsimples/design-system/src/components';
import Email from '@public/icons/email/email';
import type { ChangeEventHandler } from 'react';
import { useDesignTokens } from '../../app/providers/design_tokens_provider';

interface Props {
  value: string;
  placeholder?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

export default function AuthEmailInput(props: Props) {
  const tokens = useDesignTokens();
  const { onChange, value, placeholder } = props;

  const emailIcon = (
    <Email color={tokens.text.secondary.color} width={17} height={17} />
  );

  return (
    <Input
      leftElement={emailIcon}
      placeholder={placeholder ?? 'nome@email.com'}
      value={value}
      onChange={onChange}
      marginBottom={2}
    />
  );
}
